import { extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import styled from 'styled-components';
import { Image, StyledImage } from '@zillow/constellation';
import PropTypes from 'prop-types';

var StyledCardImage = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-gva07i-0"
})(["overflow:hidden;border-top-left-radius:inherit;border-top-right-radius:inherit;&& ", "{width:100%;max-width:100%;height:auto;}"], StyledImage);
var CardImage = function CardImage(_ref) {
  var imageProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(StyledCardImage, null, /*#__PURE__*/React.createElement(Image, imageProps));
};
CardImage.propTypes = process.env.NODE_ENV !== "production" ? {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number
} : {};
CardImage.defaultProps = {
  width: undefined,
  height: undefined
};
var CardImage$1 = CardImage;

export { StyledCardImage, CardImage$1 as default };
